/**
 * 导入 vue-ls模块
 */
import Vue from 'vue';
import Storage from 'vue-ls';

import * as _ from 'lodash';

// local storage 配置
Vue.use(_.clone(Storage), {
  namespace: 'vuealain_', // sorage 前缀
  name: 'ls', // 注入vue中的别名，this.$ls
  storage: 'local',  //储存名称：session， local，memory  本地存储
});

Vue.use(_.clone(Storage), {
  namespace: 'vuealain_ss_', // sorage 前缀  比如存入token ，就用vuealain_ss_token方式获取
  name: 'ss', // 注入vue中的别名，this.$ss
  storage: 'session',
});

//如果是local 存储到localStorage中，如果是session，存储到SessionStroage